export default "__VITE_ASSET__lG9mVJB2__"